import { inject, Injectable } from '@angular/core';
import { Routes } from '@angular/router';
import { NptAuthGuard, NptConfigurationService } from '@npt/sdk';

import { ManageKeycloak } from './components/manage-keycloak/manage-keycloak';

@Injectable({ providedIn: 'root' })
export class AppRoutesService {
    private routes: Routes = [
        { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
        {
            path: 'dashboard',
            loadComponent: () => import('./components/dashboard/dashboard').then(c => c.Dashboard),
            canActivate: [NptAuthGuard]
        },
        {
            path: 'wallet-details',
            loadComponent: () => import('./components/wallet/wallet-details/wallet-details').then(c => c.WalletDetails),
            canActivate: [NptAuthGuard]
        },
        {
            path: 'profile',
            loadComponent: () => import('./components/profile/profile').then(c => c.Profile),
            canActivate: [NptAuthGuard]
        },
        {
            path: 'request',
            canActivate: [NptAuthGuard],
            children: [
                {
                    path: 'automatic/:type',
                    loadComponent: () => import('./components/cashback-request/request-automatic/request-automatic').then(c => c.RequestAutomatic)
                },
                {
                    path: 'oneshot',
                    loadComponent: () => import('./components/cashback-request/request-oneshot/request-receive').then(c => c.RequestReceive)
                },
                { path: '**', loadComponent: () => import('./components/not-found/not-found').then(c => c.NotFound) }
            ],
        },
        {
            path: 'registrations',
            loadComponent: () => import('./components/history-registrations/registrations').then(c => c.Registrations),
            canActivate: [NptAuthGuard]
        },
        {
            path: 'history-request',
            loadComponent: () => import('./components/history-request/history-request').then(c => c.HistoryRequest),
            canActivate: [NptAuthGuard]
        },
        {
            path: 'transits',
            loadComponent: () => import('./components/transits/transits').then(c => c.Transits),
            canActivate: [NptAuthGuard]
        },
        {
            path: 'register',
            loadComponent: () => import('./components/public/customer-registration/customer-registration').then(c => c.CustomerRegistration)
        },
        {
            path: 'register-complete',
            loadComponent: () => import('./components/public/registration-complete/registration-complete').then(c => c.RegistrationComplete)
        },
        {
            path: 'cashback-request',
            loadComponent: () => import('./components/public/cashback-request/cashback-request').then(c => c.CashbackRequest)
        },
        {
            path: '**',
            loadComponent: () => import('./components/not-found/not-found').then(c => c.NotFound)
        }
    ];

    private configService = inject(NptConfigurationService);

    buildRoutes(): Routes {
        const keycloakRoute = {
            path: 'keycloak',
            loadComponent: (): Promise<typeof ManageKeycloak> => import('./components/manage-keycloak/manage-keycloak').then(c => c.ManageKeycloak),
            canActivate: [NptAuthGuard]
        };
        if (this.configService.config['keycloakPath']) {
            const wildcardIndex = this.routes.findIndex(route => route.path === '**');
            if (wildcardIndex >= 0) {
                this.routes.splice(wildcardIndex, 0, keycloakRoute);
            } else {
                this.routes.push(keycloakRoute);
            }
        }
        return this.routes;
    }
}
